package one.healthium.featureconfig.domain

object CoreFeatureConfigKeys {
    val ManageSubscription = ConfigKey.boolean(
        name = "feature_manage_subscription",
        defaultValue = false,
    )

    val EnableLogFoodScanner = ConfigKey.boolean(
        name = "feature_enable_log_food_scanner",
        defaultValue = true,
    )

    val Paywall = ConfigKey.string(
        name = "paywall",
        defaultValue = "v101_noskip",
    )

    val EnablePersonalMealPlan = ConfigKey.boolean(
        name = "feature_enable_personal_meal_plan",
        defaultValue = false,
    )
}
